export default __webpack_public_path__ + "static/media/allgemein_31.1dc66fd0.jpg";